module.exports = __webpack_public_path__ + "static/img/chat-pass.9f9f87b9.png";